<!--
 * @Description: 运维监测
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 14:20:28
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-08 09:50:03
 -->
<template>
  <div class="maintenance-service">
    <div class="line1">
      <Line1 />
    </div>
    <div class="line2">
      <Line2 />
    </div>
    <div class="line3">
      <div class="line3Left">
        <Line3Left />
      </div>
      <div class="line3Right">
        <Line3Right />
      </div>
    </div>
  </div>
</template>

<script>
import Line1 from './components/line1'
import Line2 from './components/line2'
import Line3Left from './components/line3Left'
import Line3Right from './components/line3Right'
export default {
  name: 'maintenanceService',
  components: {
    Line1,
    Line2,
    Line3Left,
    Line3Right,
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .maintenance-service {
    width: 100%;
    height: 100%;
    .line1 {
      width: 100%;
      height: 20%;
    }
    .line2 {
      width: 100%;
      height: 694px;
      margin-bottom: 50px;
    }
    .line3 {
      width: 100%;
      height: 25%;
      display: inline-flex;
      justify-content: space-around;
      align-items: center;
      .line3Left {
        width: 50%;
        height: 100%;
        display: inline-flex;
        justify-content: space-around;
        align-items: center;
      }
      .line3Right {
        width: 50%;
        height: 100%;
        display: inline-flex;
        justify-content: space-around;
        align-items: center;
      }
    }
  }
</style>
